"use client";

import { Paperclip } from "lucide-react";
import { chatAttachmentHref, cn, type ChatAttachment } from "@drpcrd/utils";

/** Shared footprint for feed chips and the input draft chip. */
export const CHAT_ATTACHMENT_CHIP_CLASSNAME =
  "box-border inline-flex h-[30px] w-fit max-w-full shrink-0 items-center gap-1 overflow-hidden py-1 pr-1.5 pl-1 text-sm leading-[22px]";

type ChatAttachmentLinkProps = {
  attachment: ChatAttachment;
  /** Own-side (right) vs other-side (left) chip styling from the mockup. */
  side: "own" | "other";
};

/**
 * Compact file chip above a chat bubble: paperclip + name (full when it
 * fits; ellipsis only when longer than the message column).
 */
export const ChatAttachmentLink = ({
  attachment,
  side,
}: ChatAttachmentLinkProps) => (
  <a
    href={chatAttachmentHref(attachment)}
    target="_blank"
    rel="noreferrer"
    title={attachment.name}
    className={cn(
      CHAT_ATTACHMENT_CHIP_CLASSNAME,
      "text-primary no-underline hover:underline",
      side === "own"
        ? "bg-primary-50 rounded-tl-lg rounded-tr-lg rounded-bl-lg"
        : "rounded-tl-lg rounded-tr-lg rounded-br-lg border border-neutral-500 bg-white",
    )}
  >
    <Paperclip
      className="text-primary h-2 w-2 shrink-0"
      size={8}
      strokeWidth={2}
      aria-hidden
    />
    <span className="min-w-0 truncate">{attachment.name}</span>
  </a>
);
